import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { AppConfigService } from '../app-config.service';
import { exportPDF, Group } from '@progress/kendo-drawing';


@Component({
  selector: 'app-lista-presencas-assembleia-pdf',
  templateUrl: './lista-presencas-assembleia-pdf.component.html',
  styleUrls: ['./lista-presencas-assembleia-pdf.component.scss']
})
export class ListaPresencasAssembleiaPdfComponent implements OnInit {

  @Input() data = {
    codCondominio: '',
    nomeCondominio: '',
    fraccaoList: [],
    permTotal: 0,
    data: '',
  };

  @ViewChild('pdfRef', { static: false }) pdfController;

  now = null;
  filename = 'default_filename';

  constructor(public appConfig: AppConfigService) { }

  ngOnInit() {}

  ngOnDestroy() {}

  generatePdf() {
    this.now = new Date();

    this.pdfController.proxyURL = this.appConfig.fileProxyUrl;
    this.pdfController.forceProxy = true;
    this.pdfController.proxyTarget = '_blank';
    this.pdfController.saveAs(this.filename + '.pdf');
  }

  getBase64() {
    return new Promise((resolve, reject) => {
      this.now = new Date();

      this.pdfController.export().then((group: Group) => exportPDF(group)).then(dataUri => {
        let base64  = dataUri.replace('data:application/pdf;base64,', '');
        base64  = base64.replace(' ', '+');

        resolve(base64);
      }).catch(err => {
        reject(err);
      });
    });
  }

  export() {
    this.now = new Date();

    return this.pdfController.export()
  }

}
